<template>
  <div :id="id" class="echarts" />
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      id: `echarts${Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)}`,
      myEchart: null
    }
  },
  computed: {

  },
  watch: {
    data: {
      handler: function() {
        this.dram()
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.dram()
  },
  methods: {
    dram() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '5%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.data.xData,
          axisLabel: {
            color: 'rgba(137, 157, 191, 1)',
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '',
          min: 0,
          // splitNumber: 4,
          nameTextStyle: {
            verticalAlign: 'top'
          },
          axisLabel: {
            color: 'rgba(137, 157, 191, 1)'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          }
        },
        series: [
          {
            name: '新激活数',
            type: 'pictorialBar',
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            itemStyle: {
              color: (params) => {
                var colorList = [
                  ['rgba(228, 173, 25, 1)', 'rgba(237, 222, 49, 1)'],
                  ['rgba(24, 111, 255, 1)', 'rgba(82, 241, 255, 1)'],
                  ['#00f1e7', '#00e6a2'],
                  ['#ffd08b', '#ff652b']
                ]
                var index = params.dataIndex
                if (params.dataIndex >= colorList.length) {
                  index = params.dataIndex - colorList.length
                }
                return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                  [{
                    offset: 0,
                    color: colorList[index][0]
                  },
                  {
                    offset: 1,
                    color: colorList[index][1]
                  }]
                )
              }
            },
            data: this.data.sData
          }
        ]
      }
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      this.myEchart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.myEchart.resize()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .echarts{
    width: 100%;
    height: 100%;
  }
</style>
